module.exports = __webpack_public_path__ + "img/product-placeholder-89.f09220a.png";